import type { ViewMoreProps } from '~/legacy/types';

const ViewMore = ({
  message = 'View More',
  to = '#',
  onClick
}: ViewMoreProps) => {
  return (
    <a className={`btn btn--view-more`} href={to} onClick={onClick}>
      {message}
    </a>
  );
};

export default ViewMore;
